import type { ApiClient, RequestOptions } from './client';
import type { ChatRequestBody, ChatResponse } from '@/types/chat';

export interface ChatApi {
  /**
   * Send a non-streaming chat message and return the full ChatResponse.
   * For streaming, use the chat-stream module.
   */
  send: (body: ChatRequestBody, options?: RequestOptions) => Promise<ChatResponse>;
}

export function createChatApi(client: ApiClient): ChatApi {
  return {
    send(body, options) {
      return client.post<ChatResponse>('/api/chat/messages', body, options);
    },
  };
}
